import { PropsWithChildren, TableHTMLAttributes } from 'react';
import classNames from 'classnames';
import className from './layout-table-body.module.css';

export default function TableBody<T extends HTMLTableSectionElement>({
  children,
  ...props
}: PropsWithChildren<TableHTMLAttributes<T>>) {
  return (
    <tbody {...props} className={classNames(className['bl-table-body'], props.className)}>
      {children}
    </tbody>
  );
}
